import { render, staticRenderFns } from "./old-calendar.vue?vue&type=template&id=537364a8&scoped=true&"
import script from "./old-calendar.vue?vue&type=script&lang=js&"
export * from "./old-calendar.vue?vue&type=script&lang=js&"
import style0 from "./old-calendar.vue?vue&type=style&index=0&id=537364a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537364a8",
  null
  
)

export default component.exports